module.exports = __webpack_public_path__ + "static/img/z6.147a4561.png";